webpackJsonp([55],{

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


function data() {
	return {
		filters: [{
			id: 1, value: 1, label: 'Día', days: 0
		}, {
			id: 2, value: 2, label: 'Semana', days: 7
		}, {
			id: 3, value: 3, label: 'Mes', days: 30
		}, {
			id: 4, value: 4, label: 'Año', days: 365
		}]
	};
}

function applyFilter(filter) {
	this.$emit('apply-filter', filter);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filters-by-time',
	data: data,
	props: {
		value: {
			type: Number,
			default: 1
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		applyFilter: applyFilter
	}
});

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".filters-by-time[data-v-79facaf4]{color:#85939e;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:408px}.filters-by-time button.btn[data-v-79facaf4]{background-color:#fff!important;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);color:#85939e;font-size:14px!important;height:40px;margin-left:14px;max-width:73px}.filters-by-time button.btn.active[data-v-79facaf4]{background-color:#29abe2!important;color:#fff}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/FiltersByTime.vue"],"names":[],"mappings":"AACA,kCACE,cAAe,AACf,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,WAAuB,CACxB,AACD,6CACI,gCAAmC,AACnC,+CAAoD,AAC5C,uCAA4C,AACpD,cAAe,AACf,yBAA2B,AAC3B,YAAa,AACb,iBAAkB,AAClB,cAAgB,CACnB,AACD,oDACM,mCAAqC,AACrC,UAAa,CAClB","file":"FiltersByTime.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.filters-by-time[data-v-79facaf4] {\n  color: #85939e;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: calc(102px * 4);\n}\n.filters-by-time button.btn[data-v-79facaf4] {\n    background-color: white !important;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n    color: #85939e;\n    font-size: 14px !important;\n    height: 40px;\n    margin-left: 14px;\n    max-width: 73px;\n}\n.filters-by-time button.btn.active[data-v-79facaf4] {\n      background-color: #29abe2 !important;\n      color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("6dcc94fc", content, true);

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(1106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79facaf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "filters-by-time"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'active': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.applyFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t" + _vm._s(filter.label) + "\n\t")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_mixins__ = __webpack_require__(56);



var loadResources = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, subsidiaries;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 2:
						_ref2 = _context.sent;
						subsidiaries = _ref2.data;

						this.subsidiaries = subsidiaries.data;
						this.idSubsidiary = this.subsidiaries[0].id;
						this.getOccupation();

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadResources() {
		return _ref.apply(this, arguments);
	};
}();

var getOccupation = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var params, dateOccupations;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						params = {
							dateStart: this.dateStart,
							dateEnd: this.dateEnd,
							idSubsidiary: this.idSubsidiary
						};
						_context2.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/occupation-rank', { params: params });

					case 3:
						dateOccupations = _context2.sent;

						this.occupation = dateOccupations.body.headers;
						this.occupationBody = dateOccupations.body.data;

					case 6:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function getOccupation() {
		return _ref3.apply(this, arguments);
	};
}();

var printReports = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var baseUrl, dateStart, dateEnd, idSubsidiary, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api' + '/report/occupancy/';
						dateStart = this.dateStart;
						dateEnd = this.dateEnd;
						idSubsidiary = this.idSubsidiary;
						name = 'Reporte Ocupaciòn';
						responseType = 'blob';
						cardModel = { occupation: [{}] };
						_context3.next = 9;
						return this.$http.post(baseUrl + '?dateStart=' + dateStart + '&dateEnd=' + dateEnd + '&idSubsidiary=' + idSubsidiary, cardModel, { responseType: responseType });

					case 9:
						response = _context3.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 12:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function printReports() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var helperMethods = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].methods;

function created() {
	this.loadResources();
}

function columnSortableEvent() {}

function deactived() {
	this.value = 0;
	this.getOccupation();
}

function arrowIconStart() {
	var arrow = this.menuStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconEnd() {
	var arrowEnd = this.menuEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowEnd;
}

function onDateFilter(filter) {
	this.value = filter.id;
	if (this.value === 3) {
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 31), 'YYYY-MM-DD');
	} else if (this.value === 2) {
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 7), 'YYYY-MM-DD');
	} else {
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["addDays"])(new Date(), 0), 'YYYY-MM-DD');
	}
	this.getOccupation();
}

function data() {
	return {
		imageOccupation: '/static/img/pie-chart-outline.svg',
		occuArray: [],
		occupationBody: [],
		idSubsidiary: '',
		occupation: [],
		dateEnd: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		dateStart: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["subDays"])(new Date(), 0), 'YYYY-MM-DD'),
		menuStart: false,
		menuEnd: false,
		active: '',
		date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
		filters: [{
			id: 1, value: 1, label: 'Día'
		}, {
			id: 2, value: 2, label: 'Semana'
		}, {
			id: 3, value: 3, label: 'Mes'
		}],
		loading: false,
		noShowData: [],
		optionButtonsCheckin: [{
			id: 1,
			icon: 'print',
			name: 'registration-card'
		}],
		printInHouse: {
			btn: { name: 'registration-card' }
		},
		rowSelected: {},
		subsidiaries: [],
		subsidiary: {},
		totalData: [],
		value: 1,
		voidData: [],
		url: 'occupancy'
	};
}

function customButtons() {
	this.printReports();
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'report-bookings',
	mixins: __WEBPACK_IMPORTED_MODULE_6__shared_mixins__["a" /* default */],
	components: {
		FiltersByTime: __WEBPACK_IMPORTED_MODULE_4__components_shared_FiltersByTime___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_2_table_run___default.a
	},
	computed: {
		arrowIconStart: arrowIconStart,
		arrowIconEnd: arrowIconEnd
	},
	created: created,
	data: data,
	methods: {
		customButtons: customButtons,
		printReports: printReports,
		deactived: deactived,
		getOccupation: getOccupation,
		columnSortableEvent: columnSortableEvent,
		loadResources: loadResources,
		onDateFilter: onDateFilter
	}
});

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".checkin-tabs .colorGreen[data-v-0ea1f2ff]{color:green}.checkin-tabs .colorRed[data-v-0ea1f2ff]{color:red}.checkin-tabs .colorYellow[data-v-0ea1f2ff]{color:#ff0}.container-button[data-v-0ea1f2ff]{left:280px;position:relative}table[data-v-0ea1f2ff],td[data-v-0ea1f2ff],th[data-v-0ea1f2ff]{border:1px solid #979797}tr[data-v-0ea1f2ff]:nth-child(2n){background-color:#f2f2f2}tr[data-v-0ea1f2ff]:hover{background-color:#ddd}td[data-v-0ea1f2ff]{color:#2f302f;padding:10px}table[data-v-0ea1f2ff]{border-collapse:collapse;width:100%}th[data-v-0ea1f2ff]{background:#545e72;color:#fff;padding:10px;text-align:center}.container-ocuppancy[data-v-0ea1f2ff]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.header-booking-data[data-v-0ea1f2ff]{height:31px;position:absolute;right:20px;text-align:right;top:52px;width:calc(100% - 230px)}.header-booking-data p[data-v-0ea1f2ff]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-0ea1f2ff]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.td-state span.booking-td[data-v-0ea1f2ff]{color:#04bee9}.td-state span.inhouse-td[data-v-0ea1f2ff]{color:#00cb28}.btn-usage[data-v-0ea1f2ff]{background-color:#fff!important;height:39px;margin:0 10px;width:55px}.border-right[data-v-0ea1f2ff]{border-right:1px solid #d8d8d8}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/reports/Occupancy-new.vue"],"names":[],"mappings":"AACA,2CACE,WAAa,CACd,AACD,yCACE,SAAW,CACZ,AACD,4CACE,UAAc,CACf,AACD,mCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,+DACE,wBAA0B,CAC3B,AACD,kCACE,wBAA0B,CAC3B,AACD,0BACE,qBAAuB,CACxB,AACD,oBACE,cAAe,AACf,YAAc,CACf,AACD,uBACE,yBAA0B,AAC1B,UAAY,CACb,AACD,oBACE,mBAAoB,AACpB,WAAe,AACf,aAAc,AACd,iBAAmB,CACpB,AACD,sCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,UAAY,CACb,AACD,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,2CACE,aAAe,CAChB,AACD,2CACE,aAAe,CAChB,AACD,4BACE,gCAAmC,AACnC,YAAa,AACb,cAAe,AACf,UAAY,CACb,AACD,+BACE,8BAAgC,CACjC","file":"Occupancy-new.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.checkin-tabs .colorGreen[data-v-0ea1f2ff] {\n  color: green;\n}\n.checkin-tabs .colorRed[data-v-0ea1f2ff] {\n  color: red;\n}\n.checkin-tabs .colorYellow[data-v-0ea1f2ff] {\n  color: yellow;\n}\n.container-button[data-v-0ea1f2ff] {\n  left: 280px;\n  position: relative;\n}\ntable[data-v-0ea1f2ff], td[data-v-0ea1f2ff], th[data-v-0ea1f2ff] {\n  border: 1px solid #979797;\n}\ntr[data-v-0ea1f2ff]:nth-child(even) {\n  background-color: #f2f2f2;\n}\ntr[data-v-0ea1f2ff]:hover {\n  background-color: #ddd;\n}\ntd[data-v-0ea1f2ff] {\n  color: #2f302f;\n  padding: 10px;\n}\ntable[data-v-0ea1f2ff] {\n  border-collapse: collapse;\n  width: 100%;\n}\nth[data-v-0ea1f2ff] {\n  background: #545e72;\n  color: #ffffff;\n  padding: 10px;\n  text-align: center;\n}\n.container-ocuppancy[data-v-0ea1f2ff] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 100%;\n}\n.header-booking-data[data-v-0ea1f2ff] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 52px;\n  width: calc(100% - 230px);\n}\n.header-booking-data p[data-v-0ea1f2ff] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-0ea1f2ff] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.td-state span.booking-td[data-v-0ea1f2ff] {\n  color: #04bee9;\n}\n.td-state span.inhouse-td[data-v-0ea1f2ff] {\n  color: #00cb28;\n}\n.btn-usage[data-v-0ea1f2ff] {\n  background-color: white !important;\n  height: 39px;\n  margin: 0 10px;\n  width: 55px;\n}\n.border-right[data-v-0ea1f2ff] {\n  border-right: 1px solid #d8d8d8;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1456:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1371);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("037c01c3", content, true);

/***/ }),

/***/ 1581:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-ocuppancy pa-1 mb-3"
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-0": "",
      "mb-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "disabled": !_vm.dateStart,
      "append-icon": _vm.arrowIconStart,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.getOccupation
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": "",
      "md-2": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.deactived
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "align-center": "",
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "label": "qp Hotels Lima",
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.getOccupation
    },
    model: {
      value: (_vm.idSubsidiary),
      callback: function($$v) {
        _vm.idSubsidiary = $$v
      },
      expression: "idSubsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('section', {
    staticClass: "filters-by-time row wrap"
  }, [_vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'activeBtn': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.onDateFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(filter.label) + "\n\t\t\t\t")])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-usage row wrap",
    attrs: {
      "to": {
        name: 'report-occupancy'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/pie-chart-outline.svg",
      "alt": "",
      "height": "25px",
      "width": "25px"
    }
  })])], 2)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-6": "",
      "md-0": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-success white--text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.customButtons
    }
  }, [_c('v-icon', [_vm._v("print")]), _vm._v("\n\t\t\t\t\tImprimir Reporte\n\t\t\t\t")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    staticClass: "checkin-tabs"
  }, [_c('v-tabs-items', [_c('table', [_c('tr', _vm._l((_vm.occupation), function(item, indexOcu) {
    return _c('th', {
      key: indexOcu
    }, [_vm._v(_vm._s(item.name)), _c('br'), _vm._v(" "), _c('span', {
      class: {
        'colorGreen': (0 < item.percent && item.percent <= 49), 'colorYellow': (50 <= item.percent && item.percent <= 79), 'colorRed': (80 <= item.percent && item.percent <= 100)
      }
    }, [_vm._v(_vm._s(item.percent) + " "), (item.percent) ? _c('span', [_vm._v("%")]) : _vm._e()])])
  })), _vm._v(" "), _vm._l((_vm.occupationBody), function(occupationTable, indexBody) {
    return _c('tr', {
      key: indexBody,
      on: {
        "actions": _vm.customButtons
      }
    }, [_c('td', [_vm._v(_vm._s(occupationTable.date))]), _vm._v(" "), _vm._l((occupationTable.roomTypes), function(typeRoom, indexRoomType) {
      return _c('td', {
        key: indexRoomType
      }, [_vm._v(_vm._s(typeRoom.value))])
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(occupationTable.occupied))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(occupationTable.free))]), _vm._v(" "), _c('td', {
      class: {
        'colorGreen': (0 < occupationTable.percent && occupationTable.percent <= 49), 'colorYellow': (50 <= occupationTable.percent && occupationTable.percent <= 79), 'colorRed': (80 <= occupationTable.percent && occupationTable.percent <= 100)
      }
    }, [_vm._v(_vm._s(occupationTable.percent))])], 2)
  })], 2)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1456)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1304),
  /* template */
  __webpack_require__(1581),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ea1f2ff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/55.14b19909cb1a15826dba.js